'use strict';

var React = require('react');

var SvgMobileChevronMajor = function SvgMobileChevronMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"
  }));
};
SvgMobileChevronMajor.displayName = "MobileChevronMajor";

exports.SvgMobileChevronMajor = SvgMobileChevronMajor;
